import { useParams } from "react-router";
import { SOFTWARE_CATALOG_ROUTE } from "Constants";
import { CatalogRoute } from "Types";
import { getCatalogRoute } from "Utils";

const useCatalogRoute = (target: CatalogRoute = {}): string => {
  const { groupId, catalogId } = useParams();

  return groupId
    ? getCatalogRoute(groupId, { catalogId, ...target })
    : `/${SOFTWARE_CATALOG_ROUTE}`;
};

export default useCatalogRoute;
